import { render, staticRenderFns } from "./RentabilidadeManage.vue?vue&type=template&id=f1998616&scoped=true"
import script from "./RentabilidadeManage.vue?vue&type=script&lang=js"
export * from "./RentabilidadeManage.vue?vue&type=script&lang=js"
import style0 from "./RentabilidadeManage.vue?vue&type=style&index=0&id=f1998616&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1998616",
  null
  
)

export default component.exports